import React from "react";
import "./DashboardGames.css";

const games = [
  {
    id: "joker-bet",
    name: "Joker Bet",
    image: "/Images/dashboard-games/CasinoJokerBet.webp",
  },
  {
    id: "wheel-bet",
    name: "Wheel Bet",
    image: "/Images/dashboard-games/wheelBetCasinoNew.webp",
  },
  {
    id: "black-jack",
    name: "Black Jack",
    image: "/Images/dashboard-games/blackJackCasinoGame.webp",
    tall: true,
  },
  {
    id: "poker",
    name: "Poker",
    image: "/Images/dashboard-games/casinoPoker.webp",
  },
  {
    id: "bet-number",
    name: "Bet Number",
    image: "/Images/dashboard-games/casinoBetNumber.webp",
  },
  {
    id: "fruit-race",
    name: "Fruit Race",
    image: "/Images/dashboard-games/casinoFruitRace1.webp",
  },
  {
    id: "live-dice",
    name: "Live Dice",
    image: "/Images/dashboard-games/casinoLiveDice.webp",
  },
  {
    id: "32-cards",
    name: "32 Cards",
    image: "/Images/dashboard-games/32casinoCards.webp",
  },
];

const DashboardGames = () => {
  return (
    <section className="dashboard-games-section" aria-label="Casino games">
      <div className="dashboard-games-grid">
        {games.map((game) => (
          <button
            key={game.id}
            type="button"
            className={[
              "dashboard-game-card",
              game.tall ? "dashboard-game-card-tall" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            aria-label={`Play ${game.name}`}
          >
            <img src={game.image} alt={game.name} />

            <span className="dashboard-game-card-overlay" aria-hidden="true" />

            <span className="dashboard-game-play-button">PLAY</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default DashboardGames;
